var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([1abct]|1s|4p|a2|ef|ft|hm|j3|lc|ot|pe|qe|qi)|n([7bimq]|0k|23|2u|57|95|bx|c5|do|jx|ya|ze)|2(57|7y|8|ci|d6|g3|hd|k4)|f([69flmwxz]|2j|44|4t|6u|bm|d3|n4|n7|ob|pr|rd|sl|to|vi|wi|wn)|q([145bvwx]|4j|j7|k4|mc|mj|v0|yb)|w([27agj]|0q|1v|57|a6|cf|ry|v4|wb)|z([06agl]|51|6y|bi|dw|f4|me|we|x5)|o([18mu]|4n|dj|f6|fo|hu|iy|qx|uh|wz|xn|yc|za|zc)|k([9fm]|ya(|a)|1f|1z|35|4h|89|av|jb|me|q9|r2|zb)|d([5efik]|30|7h|91|cm|gb|nc|pi|v7|ze)|l([3bcdu]|cd|h5|iy|sj|ym)|7([adij]|2[adg]|5z|a2|fa|gn|uw|w3)|b(3t|am|bh|kn|oc|sc|vx|w|xt|z)|9([3agl]|87|9u|be|e6|j2|ls|mq|og|p9|q6)|r([9gjmw]|02|7a|hk|ku|n6|oo|q7|xd|zx)|0([39dj]|1[5kq]|[aip]g|4y|aj|bc|bm|gn|q9|vb|xz|yx)|t([cdn]|q[8ds]|3a|3w|51|7lm|a6|ah|gm|ii|l3|llv|n9|ni|ue)|i([1kou]|r[4iz]|4i|5f|99|a2|ap|b6|c0|ct|gs|ix|kr|lwb|nj|ns|w6|wl)|x([9dlnyz]|2y|4x|a3|bv|gd|hy|jm|mx|rh|yc|zc)|h(a[58o]|1|4b|6|cx|g2|gj|j6|t8|up|wz|ya|yz)|j([cqv]|29|4f|7g|a4|dp|dv|i7|pn|wb|wf)|3([etz]|71|92|fl|j3|r4|wj)|s([37bglr]|0a|61|c1|d9|ex|he|hs|kd|kj|me|tz|vp)|v([79fp]|k[dhn]|b3|ct|fa|n4|og|sr)|1([178fiow]|00|96|f1|iz|jf|mu|qo|rv|x7)|8([2aehwx]|1s|e8|es|gu|hi|k2|nmc|ov|qc|v8|w4)|g([19x]|yb|yf|zt)|p([279ds]|02|3x|6o|n8|yv)|4(7(|6|e)|17|1h|2a|bi|eg|ft|hs|jx|uu|v|v5)|a([27gw]|3u|7y|9o|ck|cv|do|fc|ik|k3|n4|rf)|5([456kmsux]|0s|1p|6n|kk|rd|s9)|c([248k]|23|4t|8a|mi|n9)|6([13cgoqvy]|3t|8y|cd|fq|uo|v8|vyp|wr|zy)|u((|u|w)8|2l|dt|gm|hn|ji|wq)|e([59flnrtwz]|2b|2f|40|8l|ah|av|mz|tk3|vi|vw|wo)|y([2cjy]|7n|ek|g7|kw|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
